/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"

import { useList } from "react-use"
import { type ListActions } from "react-use/lib/useList"

import { type TNotification, notificationService } from "@/3514/services"
import { type TEmptyCallback } from "@/shared/types/functions"

function useNotifications(): TNotification[] {
    const [notifications, { set: setNotifications }]: [TNotification[], ListActions<TNotification>] =
        useList<TNotification>([])

    useEffect((): TEmptyCallback => notificationService.subscribe(setNotifications), [])

    return notifications
}

export { useNotifications }
